import { createApp, defineAsyncComponent } from "vue";

import SvgVue from 'svg-vue3'
import VueLazyLoad from 'vue3-lazyload'

const app = createApp({
  components: {
    VideoBackground: defineAsyncComponent(() => import('./common/VideoBackground.vue')),
    Slider: defineAsyncComponent(() => import('./common/Slider.vue')),
    SocialIcons: defineAsyncComponent(() => import('./common/SocialMediaIcons.vue')),
    ContactForm: defineAsyncComponent(() => import('./common/ContactForm.vue')),
    VideoFeed: defineAsyncComponent(() => import('./common/VideoFeed.vue')),
    PhotoGallery: defineAsyncComponent(() => import('./blocks/PhotoGallery.vue')),
    AccordionList: defineAsyncComponent(() => import('./blocks/AccordionList.vue')),
    AccordionPanels: defineAsyncComponent(() => import('./blocks/AccordionPanels.vue')),
    TabBox: defineAsyncComponent(() => import('./blocks/TabBox.vue')),
    Alerts: defineAsyncComponent(() => import('./common/Alerts.vue')),
    DocStampDeedCalculator: defineAsyncComponent(() => import('./common/DocStampDeedCalculator.vue')),
    DocStampMortCalculator: defineAsyncComponent(() => import('./common/DocStampMortCalculator.vue')),
  },

  data: () => ({
    openMenu: '',
    scrollPosition: 0,
    activeMobileNavGroup: 'about',
    activeSideBarNav: '',
    alertsOpen: false,
    isLeaving: '',
    lastEvent: undefined,
    remind_me: true,
    rememberedLinks: []
  }),

  computed: {
    mobileMenu () {
      return this.openMenu === 'mobileMenu'
    },
    howDoI () {
      return this.openMenu === 'howDoI'
    },
    searchBox () {
      return this.openMenu === 'searchBox'
    },
    isScrolling () {
      return this.scrollPosition > 0
    },
  },

  mounted () {

  },

  methods: {
    toggleMenu (menu) {
      this.openMenu = (this.openMenu != menu ? menu : '')
    },

    setMobileNavGroup (item) {
      this.activeMobileNavGroup = this.activeMobileNavGroup != item ? item : ''
    },

    toggleFaq(val){
      this.activeFaq = this.activeFaq == val ? '' : val
    },

    handleScroll (event) {
      this.scrollPosition = window.pageYOffset != undefined ? window.pageYOffset : window.scrollY
    },

    setSidebar (sidebar) {
      this.activeSideBarNav = sidebar
    },

  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

})

app.use(VueLazyLoad)
app.use(SvgVue, {
  svgPath: 'resources/svg',
  extract: false,
  svgoSettings: [
      { removeTitle: true },
      { removeViewBox: false },
      { removeDimensions: true }
  ]
})

app.mount("#app")
